export var formatAmountWithCommas = input => {
  var _a, _b;
  if (!input) {
    return input;
  }
  var value = input === null || input === void 0 ? void 0 : input.replace(/,/g, '');
  var digits = value === null || value === void 0 ? void 0 : value.split('');
  var formattedValue = '';
  var length = digits === null || digits === void 0 ? void 0 : digits.length;
  if (length > 3) {
    formattedValue = (_a = digits === null || digits === void 0 ? void 0 : digits.slice(-3)) === null || _a === void 0 ? void 0 : _a.join('');
    digits = digits === null || digits === void 0 ? void 0 : digits.slice(0, -3);
    length -= 3;
  } else {
    formattedValue = digits === null || digits === void 0 ? void 0 : digits.join('');
    digits = [];
    length = 0;
  }
  while (length > 0) {
    formattedValue = ((_b = digits === null || digits === void 0 ? void 0 : digits.slice(-2)) === null || _b === void 0 ? void 0 : _b.join('')) + ',' + formattedValue;
    digits = digits === null || digits === void 0 ? void 0 : digits.slice(0, -2);
    length -= 2;
  }
  return formattedValue;
};